export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Бұл әрекет активті біржола жояды"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жалғастырғыңыз келетініне сенімдісіз бе?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Иә"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Бас тарту"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Бұл активті тізіміңізде енді көрмейсіз."])}
}